import React from 'react';
import ScrollableTable from './ScrollableTable';
import MobileCardList, { TableColumn } from './MobileCardList';

interface ResponsiveTableProps {
  columns: TableColumn[];
  data: any[];
  isLoading?: boolean;
  onLoadMore?: () => void;
  hasMore?: boolean;
  height?: string;
  emptyMessage?: string;
  onRowClick?: (row: any) => void;
  highlightedRowId?: number | string | null;
  getRowRef?: (rowId: number | string) => React.RefObject<HTMLTableRowElement | null> | null;
  align?: 'left' | 'center' | 'right';
}

/**
 * Drop-in replacement for ScrollableTable: renders the table unchanged on
 * desktop (lg+) and the same columns/data as MobileCardList cards below lg.
 * Adopt per page by swapping the <ScrollableTable> tag for <ResponsiveTable>.
 */
export default function ResponsiveTable(props: ResponsiveTableProps) {
  const { columns, data, isLoading, onLoadMore, hasMore, emptyMessage, onRowClick } = props;

  return (
    <>
      <div className="hidden lg:block">
        <ScrollableTable {...props} />
      </div>
      <MobileCardList
        columns={columns}
        data={data}
        isLoading={isLoading}
        onLoadMore={onLoadMore}
        hasMore={hasMore}
        emptyMessage={emptyMessage}
        onRowClick={onRowClick}
      />
    </>
  );
}
